const FETCHING_USER = "@app/fetchingUser";
const FETCHING_USER_ERROR = "@app/fetchingUserError";
const FETCHING_USER_SUCCESS = "@app/fetchingUserSuccess";

const CLEAR_STORE = "@app/clearStore";

export { FETCHING_USER, FETCHING_USER_SUCCESS, FETCHING_USER_ERROR, CLEAR_STORE };
